import { format } from "date-fns";
import { useMediaQuery } from "react-responsive";

const Filter = ({
  setFilter,
  filter,
  fetch,
  onClick,
  onChange,
  provincias,
  setData,
}) => {
  const isDesktop = useMediaQuery({ minWidth: 768 });

  return (
    <div className="">


      <div
        className="row mb-4"
        style={{
          marginLeft: isDesktop ? "10vw" : "0px",
          marginRight: isDesktop ? "10vw" : "0px",
        }}
      >
        <div className="col-md-6">
          <h1 className="h2 fw-bold">USUARIOS</h1>
        </div>
        <div className="col-md-6 text-md-end">
          <button
            className="btn btn-custom-naranja text-white"
            name="añadir-usuario"
            onClick={(event) => onClick(event)}
          >
            <i className="bi bi-plus me-2"></i>NUEVO USUARIO
          </button>
        </div>
      </div>

      <div
        className="row mb-4"
        style={{
          marginLeft: isDesktop ? "10vw" : "0px",
          marginRight: isDesktop ? "10vw" : "0px",
        }}
      >
        <div className="card-body">
          <div className="row g-3 mb-3">
            <div className={`col-md-3`}>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  name="search"
                  placeholder="Buscar"
                  onChange={(e) => onChange(e)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter")
                      onClick({ target: { name: "search" } });
                  }}
                />
              </div>
            </div>
            <div className="col-md-3 mb-3">
              <select
                class="form-select"
                aria-label="Default select example"
                onChange={(e) => {
                  if (e.target.value == "todos") {
                    let params = filter;
                    delete params["filter[provincia]"];
                    setFilter({ ...params });
                    return fetch(setData, params, "/eventos");
                  }

                  setFilter({ ...filter, ["filter[provincia]"]: e.target.value });
                  let params = { ...filter, ["filter[provincia]"]: e.target.value };

                  fetch(setData, params, "/usuarios");
                }}
              >
                <option selected>Seleccionar provincia</option>
                <option value={"todos"}>Todos</option>
                {provincias.map((provincia) => {
                  return (
                    <option
                      value={provincia.provincia}
                    >{`${provincia.provincia} (${provincia.total_eventos})`}</option>
                  );
                })}
              </select>
            </div>
            <div className="col-md-3 mb-3">
              <select
                class="form-select"
                aria-label="Default select example"
                onChange={(e) => {
                  if (e.target.value == "todos") {
                    let params = filter;
                    delete params["status"];
                    setFilter({ ...params });
                    return fetch(setData, params, "/usuarios");
                  }
                  setFilter({ ...filter, ['filter[status_id]']: e.target.value });
                  let params = { ...filter, ['filter[status_id]']: e.target.value };
                  fetch(setData, params, "/usuarios");
                }}
              >
                <option selected>Seleccionar estado</option>
                <option value="todos">Todos</option>
                <option value="1">Activo</option>
                <option value="3">Pausado</option>
                <option value="4">Eliminado</option>
                <option value="3">Borrador</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filter;
